import React from "react";
import AssessmentBreadcrumbs from "@Components/assessment/AssessmentBreadcrumbs";
import AssessmentAdmin from "@Components/assessment/AssessmentAdmin";
import { useAssessmentsInstancesQuery } from "@Components/assessment/queries";
import { IAssessmentTab, isValidTab } from "@Components/assessment/types";
import { useSearchParams } from "@Utils";
import "@Styles/pages/assessmentReviewPage.scss";

const AdminContainer: React.FC = () => {
  const [searchParams] = useSearchParams();
  const assessmentParam = searchParams.get("assessment");
  const tabParam = searchParams.get("tab");

  const { data: assessmentInstances } = useAssessmentsInstancesQuery(assessmentParam); // only runs on individual assessment page

  const activeTab: IAssessmentTab = isValidTab(tabParam) ? tabParam : "users";

  const hasSubmissions = !!assessmentInstances?.find((ai) => ["submitted", "completed"].includes(ai.status));
  
  return (
    <>
      <AssessmentBreadcrumbs assessmentId={assessmentParam} hasSubmissions={hasSubmissions} tab={activeTab} />
      <AssessmentAdmin assessmentId={assessmentParam} hasSubmissions={hasSubmissions} tab={activeTab} />
    </>
  );
};

export default AdminContainer;
